import React, { useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { personas, media } from "../../content/siteContent";
import { SectionHeading } from "./primitives";
import { Reveal } from "../motion/Reveal";
import { track, EVENTS } from "../../lib/analytics";

export const Personas = () => {
  const [active, setActive] = useState(0);
  const role = personas.roles[active];

  return (
    <section data-testid="personas-section" className="bg-white py-24 lg:py-32 border-t border-hair">
      <div className="container-page">
        <SectionHeading eyebrow={personas.eyebrow}>{personas.heading}</SectionHeading>

        <div className="mt-14 grid lg:grid-cols-12 gap-10 lg:gap-16">
          {/* Tabs */}
          <div className="lg:col-span-4" role="tablist" aria-label="Roles">
            {personas.roles.map((r, i) => {
              const isActive = i === active;
              return (
                <button
                  key={r.key}
                  role="tab"
                  aria-selected={isActive}
                  data-testid={`persona-tab-${r.key}`}
                  onClick={() => {
                    setActive(i);
                    track(EVENTS.PERSONA_TAB, { role: r.label });
                  }}
                  className={`w-full text-left flex items-center justify-between gap-3 py-4 border-b border-hair transition-colors duration-300 focus-ring rounded-sm ${
                    isActive ? "text-navy" : "text-slate-ink hover:text-navy"
                  }`}
                >
                  <span
                    className={`font-display font-semibold text-base lg:text-lg tracking-tight ${
                      isActive ? "border-l-2 border-teal pl-4" : "pl-[18px]"
                    }`}
                  >
                    {r.label}
                  </span>
                  {isActive && <ArrowRight className="h-4 w-4 text-teal shrink-0" />}
                </button>
              );
            })}
          </div>

          {/* Panel */}
          <div className="lg:col-span-8">
            <motion.div
              key={role.key}
              role="tabpanel"
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
              className="border border-hair rounded-sm overflow-hidden"
            >
              <div className="aspect-[16/7] overflow-hidden border-b border-hair">
                <img src={media.personas} alt="" aria-hidden="true" className="h-full w-full object-cover" loading="lazy" />
              </div>
              <div className="p-8 lg:p-10">
                <h3 className="font-display font-extrabold text-navy text-2xl tracking-tight">{role.label}</h3>
                <div className="mt-6 grid sm:grid-cols-2 gap-x-10 gap-y-6">
                  <div>
                    <p className="eyebrow text-teal">Current challenge</p>
                    <p className="mt-2 text-slate-ink text-sm leading-relaxed">{role.challenge}</p>
                  </div>
                  <div>
                    <p className="eyebrow text-teal">What they want</p>
                    <p className="mt-2 text-slate-ink text-sm leading-relaxed">{role.want}</p>
                  </div>
                  <div>
                    <p className="eyebrow text-teal">Most relevant benefit</p>
                    <p className="mt-2 text-slate-ink text-sm leading-relaxed">{role.benefit}</p>
                  </div>
                  <div className="sm:col-span-2 border-t border-hair pt-6">
                    <p className="font-display font-semibold text-navy text-base lg:text-lg leading-snug">
                      {role.message}
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};
